import { FC, MouseEvent } from "react";
import Image from "next/image";

import icon from "@/utils/icon.helper";

// ----------------------------------------------------------------------------

export type ITeamsShareButtonProps = { url: string };

const TeamsShareButton: FC<ITeamsShareButtonProps> = (props) => {
  const { url } = props;

  // Function to handle opening the Teams share popup
  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    window.open(
      `https://teams.microsoft.com/share?href=${encodeURIComponent(url)}`, // https://blog.thoughtstuff.co.uk/2019/08/adding-a-share-to-teams-button-on-your-website-plus-variations/ --- for sharing url in microsoft teams
      "ms-teams-share-popup",
      "width=700,height=600",
    );
  };

  return (
    <div
      className="cursor-pointer rounded-sm p-1 transition-all duration-500 ease-in-out hover:bg-primary-200 hover:drop-shadow-xl"
      onClick={handleClick}
    >
      <Image
        alt="Share to Microsoft Teams"
        src={icon("teams")}
        width={20}
        height={20}
        className="size-5"
      />
    </div>
  );
};

export default TeamsShareButton;
